import { FrameSharedProps } from "UI/UI.React/frames/types";
import { IRenderer, IRendererRegistrator } from "../../types";

/**
 * Určuje prop types pro komponentu/container zobrazující LLFTemplate.
 */
export type LiteListFrameTemplateProps = FrameSharedProps;

/**
  * Interface LLFTemplate rendereru. Specifikuje metodu `canRender`
  */
export interface ILLFTemplateRenderer extends IRenderer<LiteListFrameTemplateProps> {
}

export class ILLFTemplateRenderer {
    private static _interfaces = [IRenderer];

    public static [Symbol.hasInstance](instance: any): boolean {
        return (
            instance != null &&
            this._interfaces.every((_interface) => instance instanceof _interface)
        );
    }
}

/**
  * Typ registrátoru pro LLFTemplate.
  */
export type ILLFTemplateRegistrator = ILLFTemplateRendererRegistrator<ILLFTemplateRenderer>;

/**
 * Registrator pro LLF renderer atributů
 */
export interface ILLFTemplateRendererRegistrator<RendererType extends ILLFTemplateRenderer = any> extends IRendererRegistrator {
  /**
   * Zaregistruje renderer
   * @param priority Kladné nenulové číslo, které určuje prioritu pro výběr rendereru.
   * Čím vyšší číslo, tím vyšší priorita.
   * Číslo 0 je vyhrazeno defaultním rendererům, které poskytuje multiweb.
   */
  register(renderer: RendererType): void;
}
